export const normalizeOutcomeBoard = board => {
  if (!board || board.enableOutcomeTracking === false) return null;
  const id = Number(board.id);
  if (!Number.isFinite(id) || id <= 0) return null;
  return {
    ...board,
    id
  };
};

export const getOutcomeBoardsFromTicket = ticket => {
  const tags = Array.isArray(ticket?.tags) ? ticket.tags : [];
  const map = new Map();

  tags.forEach(tag => {
    const board = normalizeOutcomeBoard(tag?.kanbanBoard);
    if (board) {
      map.set(board.id, board);
    }
  });

  if (ticket?.outcomeKanbanBoard?.enableOutcomeTracking) {
    const board = normalizeOutcomeBoard(ticket.outcomeKanbanBoard);
    if (board) {
      map.set(board.id, board);
    }
  }

  return Array.from(map.values());
};

export const getPrimaryOutcomeBoardId = ticket => {
  const boards = getOutcomeBoardsFromTicket(ticket);
  return boards.length ? boards[0].id : null;
};

export const hasOutcomeTrackingTicket = ticket =>
  getOutcomeBoardsFromTicket(ticket).length > 0;
